/**
 * 단어 단위 비교 — 광고주가 고친 원고를 보낸 원고와 대조해 보이는 데 쓴다.
 * 공백도 토큰으로 남겨 붙여 그리면 원문이 그대로 복원된다. 칼럼 한 편(수백 토큰)이라 LCS 표로 충분하다.
 */
export type DiffPart = { kind: 'same' | 'add' | 'del'; text: string };

const tokenize = (s: string) => s.split(/(\s+)/).filter((t) => t !== '');

export function diffWords(before: string, after: string): DiffPart[] {
  const a = tokenize(before);
  const b = tokenize(after);
  const n = a.length;
  const m = b.length;
  // lcs[i][j] = a[i..] 와 b[j..] 의 최장 공통 부분열 길이
  const lcs: Uint32Array[] = Array.from({ length: n + 1 }, () => new Uint32Array(m + 1));
  for (let i = n - 1; i >= 0; i--) {
    for (let j = m - 1; j >= 0; j--) {
      lcs[i]![j] = a[i] === b[j] ? lcs[i + 1]![j + 1]! + 1 : Math.max(lcs[i + 1]![j]!, lcs[i]![j + 1]!);
    }
  }
  const out: DiffPart[] = [];
  const push = (kind: DiffPart['kind'], text: string) => {
    const last = out[out.length - 1];
    if (last && last.kind === kind) last.text += text;
    else out.push({ kind, text });
  };
  let i = 0;
  let j = 0;
  while (i < n && j < m) {
    if (a[i] === b[j]) {
      push('same', a[i]!);
      i++;
      j++;
    } else if (lcs[i + 1]![j]! >= lcs[i]![j + 1]!) {
      push('del', a[i++]!);
    } else {
      push('add', b[j++]!);
    }
  }
  while (i < n) push('del', a[i++]!);
  while (j < m) push('add', b[j++]!);
  return out;
}

export const hasChanges = (parts: DiffPart[]) => parts.some((p) => p.kind !== 'same' && p.text.trim() !== '');
